<template>
  <div class="payment-apply-list">
    <!-- <div>
      付款申请，单独弄出来的一个页
    </div> -->
    <el-container>
      <el-header style="padding: 0;">
        <!-- <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
          <el-tab-pane
            v-for="tab in tabIndex"
            :key="tab.id"
            :label="tab.label"
            :name="tab.name"
          ></el-tab-pane>
        </el-tabs> -->
        <el-form
          :model="queryForm"
          :inline="true"
          label-width="100px"
          style="padding-right: 20px;"
        >
          <el-row>
            <el-col :span="6">
              <el-form-item label="提报部门：" label-width="80px">
                <el-input
                  v-model="queryForm.reportDepartmentName"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="会议议题：" label-width="80px">
                <el-input
                  v-model="queryForm.subject"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="提报日期：" label-width="80px">
                <el-date-picker
                  v-model="queryForm.submitDate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="请选择"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <div v-if="showAdvanceFilter">
              <el-col :span="6">
              <el-form-item label="是否上会：" label-width="80px">
                <el-select
                  v-model="queryForm.isOn"
                  placeholder="请选择"
                  clearable
                >
                  <el-option label="上会" :value="1"></el-option>
                  <el-option label="未上会" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            </div>
            <el-col :span="showAdvanceFilter?24:6">
              <div class="handlePanel">
                <el-button type="primary" icon @click="handleSearch">查询</el-button>
                <el-button type="info" icon @click="resetSearch">重置</el-button>
                <el-button type="text" @click="moreScreen">{{showAdvanceFilter?'收起':'高级筛选'}}</el-button>
              </div>
            </el-col>
            
          </el-row>
        </el-form>
        <el-col :span="24" style="padding: 0 20px;">
          <div class="operatePanel">
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="createPaymentApply"
              v-if="btnAuthorize.addBtn.btnEnable"
              >新建</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-edit"
              @click="editPaymentApply"
              v-if="btnAuthorize.modifyBtn.btnEnable"
              >修改</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-delete"
              @click="deletePaymentApply"
              v-if="btnAuthorize.delBtn.btnEnable"
              >删除</el-button
            >
            <!-- <el-button
              type="primary"
              icon="el-icon-s-check"
              @click="approvePaymentApply"
              v-if="btnAuthorize.approve.btnEnable"
              >审批</el-button
            > -->
            <el-button
              type="primary"
              icon="el-icon-refresh-left"
              @click="callbackPaymentApply"
              v-if="btnAuthorize.callback.btnEnable"
              >撤回</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-printer"
              @click="printPaymentApply"
              v-if="btnAuthorize.print.btnEnable"
              >打印</el-button
            >
          </div>
        </el-col>
      </el-header>
      <el-main>
        <el-table
          ref="multipleTable"
          :data="tableData"
          border
          size="mini"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          @row-click="rowClicked"
          @cell-dblclick="gotoDetail"
        >
          <el-table-column type="selection" width="54"></el-table-column>
          <el-table-column
            label="提报部门"
            show-overflow-tooltip
            prop="deptName"
          ></el-table-column>
          <el-table-column
            label="项目分类"
            show-overflow-tooltip
            prop="projectTypeValue"
          ></el-table-column>
          <el-table-column
            label="会议议题"
            show-overflow-tooltip
            prop="title"
          ></el-table-column>
          <el-table-column label="参会人员" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-for="(item, index) in scope.row.joinWorkList" :key="index"
                >{{ item.displayName || item.name }}&nbsp;</span
              >
            </template>
          </el-table-column>
          <el-table-column label="列席部门" show-overflow-tooltip>
            <template slot-scope="scope">
              <span
                v-for="(item, index) in scope.row.checkWorkList"
                :key="index"
                >{{ item.name }}&nbsp;</span
              >
            </template>
          </el-table-column>
          <el-table-column
            label="提报日期"
            prop="createTime"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="申请人"
            prop="applyUserName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="申请部门"
            prop="operatorDeptName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="审核状态"
            prop="approveStatusName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="是否上会"
            prop="isSubmitted"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <div style="display: flex; justify-content: space-between;">
          <span
            style="
              color: #666666;
              font-size: 14px;
              line-height: 32px;
              margin-top: 16px;
            "
            >显示{{
              totalCount > 0
                ? (currentPage - 1) * pageSize +
                  1 +
                  "-" +
                  (currentPage * pageSize > totalCount
                    ? totalCount
                    : currentPage * pageSize)
                : "0"
            }}，共{{ totalCount }}条记录</span
          >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          ></el-pagination>
        </div>
      </el-footer>
    </el-container>
    <!-- 快捷审批弹出框 -->
    <el-dialog title="审批" :visible.sync="dialogApproveVisible">
      <el-form
        ref="approveDialogForm"
        :model="approveFormData"
        label-width="100px"
        :rules="approveDialogRules"
      >
        <el-form-item label="会议议题">
          <el-input :value="approveFormData.title" readonly></el-input>
        </el-form-item>
        <el-form-item label="提报部门">
          <el-input :value="approveFormData.deptName" readonly></el-input>
        </el-form-item>
        <el-form-item label="项目分类">
          <el-input
            :value="approveFormData.projectTypeValue"
            readonly
          ></el-input>
        </el-form-item>
        <el-form-item label="审批意见" prop="opinion">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="-请输入-"
            maxlength="100"
            show-word-limit
            v-model="approveFormData.opinion"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="info" @click="rejectApproveDialog">驳回</el-button>
        <el-button type="primary" @click="submitApproveDialog">通过</el-button>
      </div>
    </el-dialog>
    <!-- 打印 -->
    <MeetingOrderPrint
        :visible.sync="dialogPrintVisible"
        :printData="meettingOrderData"
        v-if="dialogPrintVisible"
      >
      </MeetingOrderPrint>
  </div>
</template>

<script>
import $ from "jquery";
window.$ = require("jquery");
window.JQuery = require("jquery");
require("../meeting/plugin/jquery.PrintArea.js");
/**
 * 付款申请列表
 */
import { getProjectPayList } from "../../services/financeService";
import {
  deleteDeclaration,
  recallDeclaration,
  queryApproveProcess,
  submitApproveProcess,
  getDeclarationDetail
} from "@/services/declarationServices";
import Constants from "@/utils/consts";
import { tabIndex, getTabIndex } from "./utils";
import BillTable from "../meeting/bill/BillTable.vue";
import MeetingOrderPrint from "../meeting/bill/components/MeetingOrderPrint";
export default {
  components: {
    BillTable,
    MeetingOrderPrint
  },
  data() {
    return {
      showAdvanceFilter: false,
      btnAuthorize: {
        addBtn: { key: "create", btnEnable: false },
        modifyBtn: { key: "update", btnEnable: false },
        delBtn: { key: "delete", btnEnable: false },
        approve: { key: "approve", btnEnable: false }, //审核
        callback: { key: "callback", btnEnable: false }, //撤回
        print: { key: "print", btnEnable: false }
      },
      activeName: "first",
      currentPage: 1,
      pageSize: 10,
      tabIndex,
      queryForm: {
        reportDepartmentName: undefined, //提报部门
        subject: undefined, //会议议题
        submitDate: undefined, //提报日期
        isOn: undefined //是否上会
      },
      totalCount: 0,
      tableData: [],
      selectItems: [],
      dialogApproveVisible: false,
      approveFormData: {},
      approveDialogRules: {
        approveOpinion: [
          { required: true, message: "请输入审核意见", trigger: "blur" }
        ]
      },
      //------------打印时的数据
      dialogPrintVisible: false,
      meettingOrderData: {}, //会议提报单需要打印数据
      printTitle: "", //主题
      printContent: "", // 会议主要内容
      printDeptName: "", // 汇报部门
      printReportUserName: "", // 汇报人
      printPeople: [], // 审批人
      printTypeName: "", //  会议类型
      printJoinWorkList: [], //参会人员
      printCheckWorkList: [] // 列席部门
      //---------------------------------
    };
  },
  methods: {
    getTabIndex,
    onActive(menuCode) {
      this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.getList();
    },
    handleTabClick() {
      this.currentPage = 1;
      this.getList();
    },
    getList() {
      let params = {
        deptName: this.queryForm.reportDepartmentName, //提报部门
        createTime: this.queryForm.submitDate, //提报日期
        title: this.queryForm.subject, //会议议题
        submitStatus: this.queryForm.isOn, //是否上会， 0未上会，1已上会
        tabIndex: this.getTabIndex(this.activeName), // 查询tab，全部0待审核1通过2拒绝3
        pageIndex: this.currentPage,
        pageSize: this.pageSize
      };
      getProjectPayList(params)
        .then(res => {
          if (res.code == Constants.Code_OK) {
            let data = res.data || [];
            data.forEach(item => {
              try {
                let { joinWorkJson, checkWorkJson } = item;
                item.joinWorkList = JSON.parse(joinWorkJson);
                item.checkWorkList = JSON.parse(checkWorkJson);
              } catch (error) {
                //
              }
            });
            this.tableData = data;
            this.totalCount = res.total || 0;
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    /**
     * 查询
     */
    handleSearch() {
      this.currentPage = 1;
      this.getList();
    },
    /**
     * 重置。重置后要再查一遍
     */
    resetSearch() {
      this.queryForm = {
        reportDepartmentName: undefined,
        subject: undefined,
        submitDate: undefined,
        isOn: undefined
      };
      this.currentPage = 1;
      this.getList();
    },
    /**
     * 新建付款申请
     */
    createPaymentApply() {
      this.bus.$emit("navMenuChange", {
        routeId: "createPaymentApply",
        routeParam: {
          paymentApply: true
        }
      });
    },
    /**
     * 修改付款申请
     */
    editPaymentApply() {
      // 修改
      if (!this.selectItems || this.selectItems.length == 0) {
        this.$alert(Constants.No_Select_Tip, "提示");
        return;
      }
      if (this.selectItems.length > 1) {
        this.$alert(Constants.One_Select_Tip, "提示");
        return;
      }
      let target = this.selectItems[0];
      let { approveStatus, id, applyUserId } = target;
      let userId = sessionStorage.getItem("currentUserId");
      console.log('userId', userId);
      console.log('applyUserId', applyUserId);
      console.log('approveStatus', approveStatus);
      if (userId == applyUserId && (approveStatus == 4 || approveStatus == 1|| approveStatus == -1)) {
        // 只有自己发的提报单才能修改
        // 被拒绝了，可以修改
        // 已经撤回了，可以修改
        // 进入修改页
        this.bus.$emit("navMenuChange", {
          routeId: "paymentApplyEdit",
          routeParam: {
            id: id,
            paymentApply: true
          },
        });
      } else {
        this.$alert("当前数据不能修改", "提示");
      }
    },
    /**
     * 删除付款申请
     */
    deletePaymentApply() {
      if (!this.selectItems || this.selectItems.length == 0) {
        this.$alert(Constants.No_Select_Tip, "提示");
        return;
      }
      this.$confirm(Constants.Delete_Tip, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = [];
          this.selectItems.forEach(item => {
            ids.push(item.id);
          });
          return deleteDeclaration({ delIds: ids.join(",") });
        })
        .then(res => {
          if (res.code == Constants.Code_OK) {
            this.$alert(Constants.Ok_Msg, "提示");
            this.$nextTick(() => {
              this.getList();
            });
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          // 这里的error可能是几种类型，false-取消，Error-中途出错，string-后台返回的错误
          if (error instanceof Error) {
            this.$alert(error.message, "提示");
          }
          if (error instanceof String) {
            this.$alert(error, "提示");
          }
        });
    },
    /**
     * 审批付款申请
     */
    approvePaymentApply() {
      if (!this.selectItems || this.selectItems.length == 0) {
        this.$alert(Constants.No_Select_Tip, "提示");
        return;
      }
      if (this.selectItems.length != 1) {
        this.$alert(Constants.One_Select_Tip, "提示");
        return;
      }
      let approveTarget = this.selectItems[0];

      let { id, approveStatus } = approveTarget;
      if(approveStatus == 3) {
        this.$alert("已通过的不需要重新审批", '提示');
        return;
      }
      queryApproveProcess({
        approveUserId: sessionStorage.getItem("currentUserId"),
        id: id
      })
        .then(res => {
          if (res.code == Constants.Code_OK) {
            this.approveFormData = { ...res.data };
            this.approveFormData.title = approveTarget.title;
            this.approveFormData.projectTypeValue =
              approveTarget.projectTypeValue;
            this.approveFormData.opinion = "";
            this.approveFormData.itemId = id; // 后面提交的时候需要
            this.dialogApproveVisible = true;
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          this.$alert(error.message || error, "提示");
        });
    },
    /**
     * 撤回付款申请
     */
    callbackPaymentApply() {
      if (!this.selectItems || this.selectItems.length == 0) {
        this.$alert(Constants.No_Select_Tip, "提示");
        return;
      }
      if (this.selectItems.length > 1) {
        this.$alert(Constants.One_Select_Tip, "提示");
        return;
      }

      this.$confirm("您确定要撤回选定的提报单吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let target = this.selectItems[0];
          return recallDeclaration({ itemId: target.id, type: 'DECLARATION' });
        })
        .then(res => {
          if (res.code == Constants.Code_OK) {
            this.$alert(Constants.Ok_Msg, "提示");
            this.getList();
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          if (error instanceof Error) {
            this.$alert(error.message, "提示");
          }
          if (error instanceof String) {
            this.$alert(error, "提示");
          }
        });
    },
    /**
     * 打印付款申请
     */
    printPaymentApply() {
      if (!this.selectItems || this.selectItems.length == 0) {
        this.$alert(Constants.No_Select_Tip, "提示");
        return;
      }
      if (this.selectItems.length > 1) {
        this.$alert(Constants.One_Select_Tip, "提示");
        return;
      }
      let target = this.selectItems[0];
      getDeclarationDetail({ id: target.id })
        .then(res => {
          if (res.code == Constants.Code_OK) {
            if (!res.data.declarationPrintVO) {
              this.$confirm("请先新建会议提报单", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "info",
              })
                .then(() => {
                  //跳转新建会议提报单页面
                  this.gotoDetail(this.selectItems[0]);
                })
                .catch(() => {});
              return;
            }
            const data = res.data.declarationPrintVO || {};
            const approveInfoList = data.approveInfoList?.slice() ?? [];
            this.meettingOrderData = {
              ...data,
              approveInfoList,
              operatorDeptName: res.data.operatorDeptName,
              title: res.data.title,
              content: res.data.content,
            };
            if (res.data.checkWorkJson) {
              console.log(JSON.parse(res.data.checkWorkJson));
              this.meettingOrderData.checkWorkList = JSON.parse(
                res.data.checkWorkJson
              )
                .map((e) => e.name)
                .join("、");
            }
            this.dialogPrintVisible = true;
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    rejectApproveDialog() {
      this.doApproveSubmit(4);
    },
    submitApproveDialog() {
      this.doApproveSubmit(3);
    },
    doApproveSubmit(status) {
      this.$refs.approveDialogForm.validate(valid => {
        if (valid == false) {
          return false;
        }
        this.approveFormData.status = status;
        submitApproveProcess(this.approveFormData)
          .then(res => {
            if (res.code == Constants.Code_OK) {
              this.$alert(Constants.Ok_Msg, "提示");
              this.resetApproveForm();
              this.$nextTick(() => {
                this.getList();
              });
            } else {
              this.$alert(res.msg, "提示");
            }
          })
          .catch(error => {
            this.$alert(error.message || error, "提示");
          });
      });
    },
    resetApproveForm() {
      this.dialogApproveVisible = false;
      this.$refs.approveDialogForm.resetFields();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.currentPage = 1;
      this.getList();
    },
    handleSelectionChange(val) {
      this.selectItems = val;
    },
    rowClicked(row, event, column) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    gotoDetail(row, column, cell, event) {
      this.bus.$emit("navMenuChange", {
        routeId: "paymentApplyDetailView",
        routeParam: {
          id: row.id,
          paymentApply: true
        }
      });
    },
    moreScreen() {
      this.showAdvanceFilter = !this.showAdvanceFilter;
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/commonLayout.scss";

.payment-apply-list {
  background-color: white;
}

/deep/.el-tabs__header {
  padding-right: 0 !important;
  background: #d5e7ed !important;
}
/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: #fff;
  color: #069dbc !important;
  border-bottom-color: #e4e7ed;
}
/deep/.el-tabs__item:hover {
  color: #069dbc;
}

.search-btns {
  text-align: right;
}

.el-main {
  min-height: 200px;
  height: auto !important;
}
</style>
